import DateFnsUtils from '@date-io/date-fns';
import React, { useEffect, useState } from 'react';
import trLocale from 'date-fns/locale/tr';
import SearchIcon from '@material-ui/icons/Search';
import { sc, moneyFormat } from 'src/utils/Common';
import {
  Card,
  Breadcrumbs,
  Link,
  Typography,
  CardContent,
  Container,
  Divider,
  Grid,
  TextField,
  ThemeProvider,
  MenuItem,
  Backdrop,
  CircularProgress,
  Button,
  Snackbar
} from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core/styles';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import axios from 'src/utils/axios';

import { getUser } from 'src/utils/Common';
import Alert from 'src/components/Alert';
import ExcelExport from 'src/components/ExcelExport';

const useStyles = makeStyles(theme => ({
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0)'
  },
  root: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  cardscontent: {
    minHeight: 300
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  tableRow: {
    '&$hover:hover': {
      backgroundColor: '#DEF5E5'
    }
  },
  tableCell: {
    '$hover:hover &': {
      color: 'black'
    }
  },
  hover: {},
  searchB: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconB: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInputB: {
    flexGrow: 1
  },
  searchButtonB: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  }
}));

function MyReturnsReport() {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const SessionUser = getUser();
  const [StartDateSearch, setStartDateSearch] = useState(
    moment()
      .startOf('day')
      .add(-7, 'days')
      .add(12, 'hours')
      .format('YYYY-MM-DD')
  );
  const [EndDateSearch, setEndDateSearch] = useState(new Date());
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [ResponseType, setResponseType] = useState('success');
  const [myReturnsDetail, setMyReturnsDetail] = React.useState(false);
  const [myReturnsDataDetail, setMyReturnsDataDetail] = React.useState([]);
  const [ResponseDsc, setResponseDsc] = useState('');
  const [loading, setLoading] = useState(false);
  const [workOrderId, setWorkOrderId] = useState('');
  const [returnsData, setReturnsData] = useState([]);

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const localeMap = {
    tr: trLocale
  };

  const locale = localStorage.getItem('i18nextLng');

  const siyah = '#424242';

  const materialTheme = createMuiTheme({
    palette: {
      primary: {
        contrastText: '#FFFFFF',
        dark: siyah,
        main: siyah,
        light: siyah
      }
    }
  });

  const handleChangeStartDateSearch = e => {
    setStartDateSearch(e);
  };
  const handleChangeEndDateSearch = e => {
    setEndDateSearch(e);
  };

  const exportData = data => {
    var json = [];

    data.map(row =>
      row.myReturnsDataDetail
        ? row.myReturnsDataDetail.map(det => {
            var temp = {};
            temp.lblWorkOrderId = row.WorkOrderId;
            temp.lblMaterial = row.MaterialCode;
            temp.lblMaterialOrder = row.MaterialOrder;
            temp.lblMaterialOrderQty = row.MaterialOrderQty;
            temp.lblMMDocument = row.MMDocument;
            temp.lblMMDocumentQty = row.MMDocumentQty;
            temp.lblReturnDocument = row.ReturnDocument;
            temp.lblReturnDocumentQty = row.ReturnDocumentQty;
            temp.lblQtyDifference = row.QtyDifference;
            json.push(temp);
          })
        : null
    );

    return json;
  };


  const GetAllMyReturns = () => {
    const StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
    const EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
    const Request = {
      WorkOrderId: workOrderId ? workOrderId : null,
      StartDate: StartDate,
      EndDate: EndDate,
      ServiceShopId: SessionUser.ServiceShopId
    };

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };

    try {
      axios.post('/GetAllMyReturns', Request, RequestHeaders)
      .then(response => {
        if (response.data.length > 0) {
          setReturnsData(response.data);
        } else {
          setReturnsData([]);
          setResponseType('warning');
          setResponseDsc(t('lblNoResultFound'));
          setOpenSnackbar(true);
        }
      });
    } catch (error) {
      setResponseType('error');
      setResponseDsc(error.message);
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Page>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          message={ResponseDsc}
          variant={ResponseType}
        />
      </Snackbar>
      <Container maxWidth="xl" spacing={1}>
        <Breadcrumbs>
          <Link color="inherit">Sirius</Link>
          <Typography color="textPrimary">{t('Material_Order')}</Typography>
          <Typography color="textPrimary">{t('Create')}</Typography>
          <Typography color="textPrimary">{t('lblMyReturns')}</Typography>
        </Breadcrumbs>
        <Divider />
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={3} lg={3}>
                <TextField
                  disabled
                  size="small"
                  fullWidth
                  label={t('lblServiceShop')}
                  id="ServiceShop"
                  variant="outlined"
                  value={
                    SessionUser.ServiceShopCode +
                    '-' +
                    SessionUser.ServiceShopName
                  }
                />
              </Grid>
              <Grid item xs={12} sm={2} lg={2}>
                <TextField
                  size="small"
                  id="WorkOrderId"
                  autoComplete="no"
                  value={workOrderId}
                  onChange={event => setWorkOrderId(event.target.value)}
                  fullWidth
                  label={t('lblWorkOrderId')}
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sm={2} lg={2}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localeMap[locale]}
                  >
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      id="orderDate"
                      size="small"
                      invalidDateMessage={t('hatali_tarih')}
                      format="dd.MM.yyyy"
                      fullWidth
                      label={t('BaslangicTarihi')}
                      variant="outlined"
                      value={StartDateSearch}
                      onChange={e => handleChangeStartDateSearch(e)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={12} sm={2} lg={2}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localeMap[locale]}
                  >
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      id="orderDate"
                      size="small"
                      invalidDateMessage={t('hatali_tarih')}
                      format="dd.MM.yyyy"
                      fullWidth
                      autoComplete="off"
                      label={t('BitisTarihi')}
                      variant="outlined"
                      value={EndDateSearch}
                      onChange={e => handleChangeEndDateSearch(e)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={12} sm={1} lg={1}>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: '#1E5128',
                    color: 'white'
                  }}
                  fullWidth
                  endIcon={<SearchIcon />}
                  onClick={GetAllMyReturns}
                >
                  {t('search')}
                </Button>
              </Grid>
              <Grid item xs={12} sm={2} lg={2}>
                <ExcelExport JsonData={exportData(returnsData)} />
              </Grid>
            </Grid>
          </CardContent>
          <CardContent>
            <TableContainer className={classes.container}>
              <Table
                stickyHeader
                aria-label="sticky table"
                className={classes.table}
                size="small"
              >
                <TableHead>
                  <TableRow>
                    <TableCell align="left">{t('lblWorkOrderId')}</TableCell>
                    <TableCell align="left">{t('lblMaterial')}</TableCell>
                    <TableCell align="left">{t('lblMaterialOrder')}</TableCell>
                    <TableCell align="left">
                      {t('lblMaterialOrderQty')}
                    </TableCell>
                    <TableCell align="left">{t('lblMMDocument')}</TableCell>
                    <TableCell align="left">{t('lblMMDocumentQty')}</TableCell>
                    <TableCell align="left">
                      {t('lblReturnDocument')}
                    </TableCell>
                    <TableCell align="left">
                      {t('lblReturnDocumentQty')}
                    </TableCell>
                    <TableCell align="left">
                      {t('lblQtyDifference')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  { returnsData ?
                    returnsData.map(row =>
                              <TableRow
                                key={row.Id}
                                hover
                                classes={{ hover: classes.hover }}
                                className={classes.tableRow}
                              >
                                <TableCell align="left">
                                  {row.WorkOrderId}
                                </TableCell>
                                <TableCell align="left">
                                  {row.MaterialCode}
                                </TableCell>
                                <TableCell align="left">
                                  {row.MaterialOrder}
                                </TableCell>
                                <TableCell align="left">
                                  {row.MaterialOrderQty}
                                </TableCell>
                                <TableCell align="left">
                                  {row.MMDocument}
                                </TableCell>
                                <TableCell align="left">
                                  {row.MMDocumentQty}
                                </TableCell>
                                <TableCell align="left">
                                  {row.ReturnDocument}
                                </TableCell>
                                <TableCell align="left">
                                  {row.ReturnDocumentQty}
                                </TableCell>
                                <TableCell align="left">
                                  {row.QtyDifference}
                                </TableCell>
                              </TableRow>
                            )
                    : null}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}

export default MyReturnsReport;
